module.exports = __webpack_public_path__ + "img/10.a3295b27.jpg";